import {
    LOADING_TOGGLE_ACTION as KM_LOADING_TOGGLE_ACTION,
    KYC_SETTING_LIST_INITIATED,
    KYC_SETTING_INITIATED,
    KYC_SETTING_LIST_LOADED,
    KYC_SETTING_LOADED,
    KYC_SETTING_FAILED,
    KYC_SETTING_CREATED,
    KYC_SETTING_UPDATED,
    KYC_SETTING_DELETED,
    CLEAR_CURRENT_KYC_SETTING,
    CLEAR_ERRORS as CLEAR_KM_ERRORS,
    SET_CURRENT_PAGE as KM_SET_CURRENT_PAGE,
    SET_FILTERS as KM_SET_FILTERS
} from '../actions/KycMasterActions';

import {
    LOADING_TOGGLE_ACTION as CK_LOADING_TOGGLE_ACTION,
    COMPANY_KYC_LIST_INITIATED,
    COMPANY_KYC_INITIATED,
    COMPANY_KYC_LIST_LOADED,
    COMPANY_KYC_LOADED,
    COMPANY_KYC_FAILED,
    COMPANY_KYC_CREATED,
    COMPANY_KYC_UPDATED,
    COMPANY_KYC_DELETED,
    KYC_MASTERS_LOADED,
    CLEAR_CURRENT_COMPANY_KYC,
    CLEAR_ERRORS as CLEAR_CK_ERRORS,
    SET_CURRENT_PAGE as CK_SET_CURRENT_PAGE,
    SET_FILTERS as CK_SET_FILTERS
} from '../actions/CompanyKycActions';

const initialState = {
    // KYC Master (settings)
    kycSettings: [],
    currentKycSetting: null,
    listLoading: false,
    loading: false,
    error: null,
    pagination: {
        totalRecords: 0,
        totalPages: 0,
        currentPage: 1,
        pageSize: 10,
        hasNext: false,
        hasPrevious: false
    },
    filters: {
        search: '',
        status: '',
        kycType: '',
        documentType: '',
        isRequired: ''
    },

    // Company KYC
    listdata: [],
    data: {},
    kycMasters: [],
    companyLoading: false,
    companyListLoading: false,
    companyError: null,
    companyPagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        pageSize: 10,
        hasNext: false,
        hasPrevious: false
    },
    companyFilters: {},
    success: false
};

export default function KycReducer(state = initialState, action) {
    switch (action.type) {
        // --- KYC Master Cases ---
        case KM_LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
                error: action.payload ? null : state.error
            };

        case KYC_SETTING_LIST_INITIATED:
            return {
                ...state,
                listLoading: true,
                error: null
            };

        case KYC_SETTING_INITIATED:
            return {
                ...state,
                loading: true,
                error: null
            };

        case KYC_SETTING_LIST_LOADED:
            return {
                ...state,
                kycSettings: action.payload.data || [],
                pagination: action.payload.pagination || state.pagination,
                listLoading: false,
                error: null
            };

        case KYC_SETTING_LOADED:
            return {
                ...state,
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_FAILED:
            return {
                ...state,
                loading: false,
                listLoading: false,
                error: action.payload
            };

        case KYC_SETTING_CREATED:
            return {
                ...state,
                kycSettings: [action.payload, ...state.kycSettings],
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_UPDATED:
            return {
                ...state,
                kycSettings: state.kycSettings.map(item =>
                    item.id === action.payload.id ? action.payload : item
                ),
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_DELETED:
            return {
                ...state,
                kycSettings: state.kycSettings.filter(item =>
                    item.id !== action.payload
                ),
                loading: false,
                error: null
            };

        case CLEAR_CURRENT_KYC_SETTING:
            return {
                ...state,
                currentKycSetting: null,
                error: null
            };

        case CLEAR_KM_ERRORS:
            return {
                ...state,
                error: null
            };

        case KM_SET_CURRENT_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    currentPage: action.payload
                }
            };

        case KM_SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        // --- Company KYC Cases ---
        case CK_LOADING_TOGGLE_ACTION:
            return {
                ...state,
                companyLoading: action.payload,
                companyError: action.payload ? null : state.companyError
            };

        case COMPANY_KYC_LIST_INITIATED:
            return {
                ...state,
                companyListLoading: true,
                companyError: null
            };

        case COMPANY_KYC_INITIATED:
            return {
                ...state,
                companyLoading: true,
                companyError: null
            };

        case COMPANY_KYC_LIST_LOADED:
            return {
                ...state,
                listdata: action.payload.data || [],
                companyPagination: {
                    totalRecords: action.payload.pagination?.totalRecords || 0,
                    totalPages: action.payload.pagination?.totalPages || 1,
                    currentPage: action.payload.pagination?.currentPage || 1,
                    pageSize: action.payload.pagination?.limit || 10,
                    hasNext: action.payload.pagination?.hasNext || false,
                    hasPrevious: action.payload.pagination?.hasPrevious || false
                },
                companyListLoading: false,
                companyError: null,
                success: true
            };

        case COMPANY_KYC_LOADED:
            return {
                ...state,
                data: action.payload || {},
                companyLoading: false,
                companyError: null,
                success: true
            };

        case COMPANY_KYC_FAILED:
            return {
                ...state,
                companyLoading: false,
                companyListLoading: false,
                companyError: action.payload,
                success: false
            };

        case COMPANY_KYC_CREATED:
            return {
                ...state,
                data: action.payload || {},
                companyLoading: false,
                companyError: null,
                success: true
            };

        case COMPANY_KYC_UPDATED:
            return {
                ...state,
                data: action.payload || {},
                listdata: state.listdata.map(item =>
                    item.id === action.payload?.id ? action.payload : item
                ),
                companyLoading: false,
                companyError: null,
                success: true
            };

        case COMPANY_KYC_DELETED:
            return {
                ...state,
                listdata: state.listdata.filter(item => item.id !== action.payload),
                companyLoading: false,
                companyError: null,
                success: true
            };

        case KYC_MASTERS_LOADED:
            return {
                ...state,
                kycMasters: action.payload || [],
                companyLoading: false,
                companyError: null,
                success: true
            };

        case CLEAR_CURRENT_COMPANY_KYC:
            return {
                ...state,
                data: {},
                companyError: null,
                success: false
            };

        case CLEAR_CK_ERRORS:
            return {
                ...state,
                companyError: null
            };

        case CK_SET_CURRENT_PAGE:
            return {
                ...state,
                companyPagination: {
                    ...state.companyPagination,
                    currentPage: action.payload
                }
            };

        case CK_SET_FILTERS:
            return {
                ...state,
                companyFilters: action.payload
            };

        default:
            return state;
    }
}
